/**
 * Server-side fetch adapter — modern implementation: Node's native `fetch` (undici).
 * Same API as `./index.ts`.
 */
export const getServerFetch = () => ({
	fetch: (...args: Parameters<typeof fetch>) => fetch(...args),
	Response,
});
